export const APP_INSIGHTS_CONNECTION_STRING = import.meta.env
  .VITE_APP_INSIGHTS_CONNECTION_STRING;

export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL || "http://localhost:1337";

/**
 * Stripe's publishable key, safe to expose client-side (unlike
 * `STRIPE_SECRET_KEY`, which never leaves the backend — see
 * `home-portal-backend/src/stripe/stripe.config.ts`). Follows this app's
 * existing env-var convention: a `VITE_`-prefixed build-time variable,
 * exported as a plain constant from this file (see `BACKEND_URL` above).
 */
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "";
